module.exports = __webpack_public_path__ + "static/media/Drive.b351937b.png";